import { decompressSync, gzipSync, strFromU8, strToU8 } from "fflate";

export function compress(data: any) : string {
  return Buffer.from(gzipSync(strToU8(JSON.stringify(data)))).toString('base64');
}

export function decompress(data: string) : any {
  return JSON.parse(strFromU8(decompressSync(new Uint8Array(Buffer.from(data, 'base64')))));
}